import { useCallback } from 'react';
import { useStartupLoading } from '../contexts/StartupLoadingContext';

export const useBackendWarmup = () => {
  const { checkAndWarmupBackend } = useStartupLoading();

  const ensureBackendWarm = useCallback(async (): Promise<boolean> => {
    const lastActivity = localStorage.getItem('last_backend_activity');
    const now = Date.now();
    const lastActivityTime = lastActivity ? parseInt(lastActivity) : 0;
    const timeSinceLastActivity = now - lastActivityTime;
    
    // If more than 15 minutes since last activity, check if backend is cold
    const mightBeCold = !lastActivity || timeSinceLastActivity > 15 * 60 * 1000;
    
    if (mightBeCold) {
      // console.log('[BackendWarmup] Checking if backend needs warmup...');
      return await checkAndWarmupBackend();
    }
    
    // Backend should still be warm
    return true;
  }, [checkAndWarmupBackend]);

  return { ensureBackendWarm };
}; 